// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Code as RawCode } from "lucide-react";
export const Code = /* @__PURE__ */ createIcon(RawCode, "Code", 2);
